var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/04b5e1e2a81d499c5c9d7aa1f5f640d9.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1997b1d52305cc81622e302f01f88a8e.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1a792da0acb064859d476f5702df16f3.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3e934d7bd81853c12756cf07962affa6.js').default;
var scope_4 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/689e783d05ee98172a9f1b1e52b14761.js').default;
var scope_5 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6c0f268121bcc1e5538c10a94e972c7d.js').default;
var scope_6 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/77f7b771c389462b5d9df2f25510dc5e.js').default;
var scope_7 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/82eda1be1134e8f8257d322b5063f7ed.js').default;
var scope_8 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8f44991fe277339c1b77682fc0976f78.js').default;
var scope_9 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9b398b0805ea9a33dc434bfc2fa9e441.js').default;
var scope_10 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9e8fb04760654f7a154d360d309a66b8.js').default;
var scope_11 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ac24810e40e8b0e4c311a42fd968769b.js').default;
var scope_12 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b9671b2ae578facfb0bc05f64045ead6.js').default;
var scope_13 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ba75ba82256035a8fc08c3a6bc47b8ed.js').default;
var scope_14 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bca9af9aef44ebc2cb3cf54720aa8ee6.js').default;
var scope_15 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c18a89dc6fc5d802b0911e1295692815.js').default;
var scope_16 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c580f75f60e1c69d26976165b96e2250.js').default;
var scope_17 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d17e251e2571d87a64d76812cb1db820.js').default;
var scope_18 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dc3759988f08218538f6fedc69ded26e.js').default;
var scope_19 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_20 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ed8bef7e6c45d2e3f7ee7b895595615f.js').default;
var scope_21 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ef693dadd4334684687444d211cfe98f.js').default;
var scope_22 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f770e0d63c6fcc1ee565f92a6dcf2017.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14,
scope_15,
scope_16,
scope_17,
scope_18,
scope_19,
scope_20,
scope_21,
scope_22 )
    